import type { EventData } from "../data";

interface SpeakerProps {
  event: EventData;
}

const Speaker: React.FC<SpeakerProps> = ({ event }) => {
  const bioParts = event.speaker.bio.split(event.speaker.name);

  return (
    <section className="bg-white pb-16 pt-4 md:py-24 px-4 md:px-6">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-[auto_1fr] gap-10 md:gap-16 items-start">
        <div data-aos="fade-up" className="flex flex-col items-start">
            <img
              src={event.speaker.image}
              alt={event.speaker.name}
              className="relative w-[357px] h-[380px] object-cover rounded-md"
            />
          <p className="font-[550] text-lg text-[#050B17] mt-6">{event.speaker.name}</p>
          <p className="text-base text-[#475467]">{event.speaker.role}</p>
        </div>

        <div data-aos="fade-up" data-aos-delay="100">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-[550] text-[#050B17] mb-7">
            Our Speaker
          </h2>
          <p className="text-base md:text-[22px] text-[#475467] leading-relaxed">
            {bioParts.map((part, index) => (
              <span key={`${event.speaker.name}-${index}`}>
                {part}
                {index < bioParts.length - 1 && (
                  <span className="font-[550] text-[#1D2939]">{event.speaker.name}</span>
                )}
              </span>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
};

export { Speaker };
